// src/services/httpClient.js
import axios from "axios";

const { REACT_APP_REST_URL } = process.env;

const httpClient = axios.create({
  baseURL: REACT_APP_REST_URL,
  headers: {
    "Content-Type": "application/json"
  }
});

// ✅ Add response interceptor
httpClient.interceptors.response.use(
  response => response, // return response as-is on success
  error => {
    const { response } = error;

    // Global error handling
    if (response) {
      switch (response.status) {
        case 400:
          console.error("Bad request:", response.data?.message || response.statusText);
          break;
        case 401:
          console.warn("Unauthorized - redirecting to login.");
          // localStorage.clear();  // optionally clear tokens
          window.location.href = "/login"; // redirect to login
          break;
        case 403:
          console.error("Forbidden:", response.data?.message);
          break;
        case 404:
          console.error("Resource not found.");
          break;
        case 500:
          console.error("Server error.");
          break;
        default:
          console.error(`Error ${response.status}:`, response.data?.message || response.statusText);
      }
    } else {
      console.error("Network or CORS error:", error.message);
    }

    // Optionally show a toast (if using something like react-toastify)
    // toast.error(response?.data?.message || "An error occurred");

    return Promise.reject(error); // still propagate error to components if needed
  }
);

export default httpClient;
